import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import { isPrivateStorageURL, loadPrivateBlob } from '../utils/privateStorage';

export default function usePrivateMedia(source) {
  const [result, setResult] = useState(null);
  const [uid, setUid] = useState(auth.currentUser?.uid);
  useEffect(() => onAuthStateChanged(auth, (user) => setUid(user?.uid)), []);
  useEffect(() => {
    if (!isPrivateStorageURL(source) || !uid) return undefined;
    const controller = new AbortController();
    let objectURL;
    loadPrivateBlob(source, controller.signal).then((blob) => {
      if (controller.signal.aborted) return;
      objectURL = URL.createObjectURL(blob);
      setResult({ source, uid, url: objectURL });
    }).catch(() => {
      if (!controller.signal.aborted) setResult({ source, uid, url: null });
    });
    return () => { controller.abort(); if (objectURL) URL.revokeObjectURL(objectURL); };
  }, [source, uid]);
  if (!isPrivateStorageURL(source)) return source;
  if (!uid) return null;
  return result?.source === source && result?.uid === uid ? result.url : undefined;
}
